import { useState } from 'react';
import { LexicalErrorBoundary } from '@lexical/react/LexicalErrorBoundary';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import { ListPlugin } from "@lexical/react/LexicalListPlugin";
import { CheckListPlugin } from "@lexical/react/LexicalCheckListPlugin";
import { ContentEditable } from '@client/shadcn/lexical/editor/editor-ui/content-editable';
import React from "react";
import { ToolbarPlugin } from '@client/shadcn/lexical/editor/plugins/toolbar/toolbar-plugin';
import { BlockFormatDropDown } from '@client/shadcn/lexical/editor/plugins/toolbar/block-format-toolbar-plugin';
import { FormatBulletedList } from '@client/shadcn/lexical/editor/plugins/toolbar/block-format/format-bulleted-list';
import { FormatCheckList } from '@client/shadcn/lexical/editor/plugins/toolbar/block-format/format-check-list';
import { FormatHeading } from '@client/shadcn/lexical/editor/plugins/toolbar/block-format/format-heading';
import { FormatNumberedList } from '@client/shadcn/lexical/editor/plugins/toolbar/block-format/format-numbered-list';
import { FormatParagraph } from '@client/shadcn/lexical/editor/plugins/toolbar/block-format/format-paragraph';
import { FormatQuote } from '@client/shadcn/lexical/editor/plugins/toolbar/block-format/format-quote';
import { ElementFormatToolbarPlugin } from '@client/shadcn/lexical/editor/plugins/toolbar/element-format-toolbar-plugin';
import { TabIndentationPlugin } from "@lexical/react/LexicalTabIndentationPlugin"
import { LinkToolbarPlugin } from '@client/shadcn/lexical/editor/plugins/toolbar/link-toolbar-plugin';
import { ClickableLinkPlugin } from "@lexical/react/LexicalClickableLinkPlugin";
import { LinkPlugin } from '@client/shadcn/lexical/editor/plugins/link-plugin';
import { AutoLinkPlugin } from '@client/shadcn/lexical/editor/plugins/auto-link-plugin';
import { FloatingLinkEditorPlugin } from '@client/shadcn/lexical/editor/plugins/floating-link-editor-plugin';
import { FloatingTextFormatToolbarPlugin } from '@client/shadcn/lexical/editor/plugins/floating-text-format-plugin';

interface Props {
    readOnly?: boolean;
}

export function Plugins(props: Props) {
  const [floatingAnchorElem, setFloatingAnchorElem] =
    useState<HTMLDivElement | null>(null);

  const onRef = (_floatingAnchorElem: HTMLDivElement) => {
    if (_floatingAnchorElem !== null) {
      setFloatingAnchorElem(_floatingAnchorElem);
    }
  };

  return (
    <div className="relative">
      {props.readOnly ? null : 
        <ToolbarPlugin>
          {({ blockType }) => (
            <div className="vertical-align-middle sticky top-0 z-10 flex gap-2 overflow-auto border-b p-1">
              <BlockFormatDropDown>
                <FormatParagraph />
                <FormatHeading levels={['h1', 'h2', 'h3']} />
                <FormatNumberedList />
                <FormatBulletedList />
                <FormatCheckList />
                <FormatQuote />
              </BlockFormatDropDown>

              <LinkToolbarPlugin />
              <ElementFormatToolbarPlugin />
            </div>
          )}
        </ToolbarPlugin>
      }
      <div className="relative">
        <RichTextPlugin
          contentEditable={
            <div className="">
              <div className="" ref={onRef}>
                {props.readOnly 
                  ? <ContentEditable placeholder={''} className='p-0' />
                  : <ContentEditable placeholder={'Start typing ...'} />
                }
              </div>
            </div>
          }
          ErrorBoundary={LexicalErrorBoundary}
        />
        <ListPlugin />
        <CheckListPlugin />
        <TabIndentationPlugin />
        <ClickableLinkPlugin />
        <AutoLinkPlugin />
        <LinkPlugin />
        <FloatingLinkEditorPlugin anchorElem={floatingAnchorElem} />
        <FloatingTextFormatToolbarPlugin anchorElem={floatingAnchorElem} />
      </div>
      {/* actions plugins */}
    </div>
  );
}
